import { Button, CircularProgress, Stack, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const [data, setData] = useState({ username: "", password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);

  const validateInput = (formData) => {
    const username = (formData.username || "").trim();
    const password = (formData.password || "").trim();
    const confirmPassword = (formData.confirmPassword || "").trim();

    if (!username) {
      enqueueSnackbar("Username is a required field", { variant: "warning" });
      return false;
    }
    if (username.length < 6) {
      enqueueSnackbar("Username must be at least 6 characters", { variant: "warning" });
      return false;
    }
    if (!password) {
      enqueueSnackbar("Password is a required field", { variant: "warning" });
      return false;
    }
    if (password.length < 6) {
      enqueueSnackbar("Password must be at least 6 characters", { variant: "warning" });
      return false;
    }
    if (password !== confirmPassword) {
      enqueueSnackbar("Passwords do not match", { variant: "warning" });
      return false;
    }
    return true;
  };

  const register = async (formData) => {
    setLoading(true);
    try {
      await axios.post(`${config.endpoint}/auth/register`, {
        username: formData.username,
        password: formData.password,
      });

      enqueueSnackbar("Registered successfully", { variant: "success" });
      history.push("/login");
    } catch (err) {
      const message =
        err?.response?.data?.message || "Something went wrong. Please try again.";
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!validateInput(data)) return;
    register(data);
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" minHeight="100vh">
      <Header hasHiddenAuthButtons />
      <Box className="content">
        <Stack spacing={2} className="form">
          <Typography variant="h4" className="title">
            Register
          </Typography>

          <TextField
            label="Username"
            name="username"
            value={data.username}
            onChange={(e) => setData((p) => ({ ...p, username: e.target.value }))}
            fullWidth
          />
          <TextField
            label="Password"
            type="password"
            name="password"
            value={data.password}
            onChange={(e) => setData((p) => ({ ...p, password: e.target.value }))}
            fullWidth
          />
          <TextField
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            value={data.confirmPassword}
            onChange={(e) => setData((p) => ({ ...p, confirmPassword: e.target.value }))}
            fullWidth
          />

          <Button variant="contained" onClick={handleSubmit} disabled={loading} fullWidth>
            {loading ? <CircularProgress size={24} /> : "Register"}
          </Button>

          <Typography align="center">
            Already have an account? <Link to="/login">Login here</Link>
          </Typography>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
